import { Injectable, signal } from '@angular/core';

/**
 * Open/close state for the Super Admin User panel. The trigger lives in the
 * top nav but the dialog is hosted by MainComponent, OUTSIDE the fixed <nav>:
 * the nav is its own stacking context (fixed, z-50), so a backdrop rendered
 * inside it can't dim the nav's own menu strip.
 */
@Injectable({ providedIn: 'root' })
export class SuperAdminUserDialogService {
  readonly isOpen = signal(false);

  open(): void {
    this.isOpen.set(true);
  }

  close(): void {
    this.isOpen.set(false);
  }
}
